export const PLAYABLE_BOUND = 78;
export const TERRAIN_SIZE = PLAYABLE_BOUND * 2 + 8;
export const minimapScale = (size) => (size - 16) / (PLAYABLE_BOUND * 2);
export const minimapHeading = (yaw) => Math.PI - yaw;

export function planHealing(hp, maxHp, blood) {
  if (hp >= maxHp) return { ok: false, reason: 'full' };
  if (blood < 30) return { ok: false, reason: 'blood' };
  return { ok: true, hp: Math.min(maxHp, hp + 24), blood: blood - 30 };
}
